import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import documentService from "./document-upload-service";
import Utility from "../../../shared/utility.js";
import router from "../../../router/router";
export default {
  data: () => ({
    userId: EncryptUtility.localStorageDecrypt("userID"),
    route: "",
    mainPage: "",
    subPage: "",
    subPageUrl: "",
    appPageName: "",
    pageName: "",
    backSlash: true,
    backSlashParent: true,
    selectedAccountName: "",
    accountOptions: [],
    accountManager: "",
    backupManager: "",
    selectedOriginID: "",
    originOptions: [],
    selectedTypeName: "",
    typeOptions: [],
    selectedDocumentNum: "",
    documentTitle: "",
    versionRevision: "",
    author: "",
    engineer: "",
    engineerOptions: [],
    authorOptions: [],
    timeRequired: "",
    statusID: "",
    statusOptions: "",
    difficultyID: "",
    difficultyOptions: [],
    managementDoc: false,
    applicablePersonnel: "",
    personnelOptions: [],
    trainingRequired: false,
    file: "",
    dragging: false,
    disableSubmit: true,
    disableAccountName: false,
    draftVersion: false,
    accountMastersDetails: [],
    disableSaveDraftVersion: false,
    fileOther: [],
    draggingOther: false,
    required: [(v) => !!v || "Field is required"],
    max20Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 20 || "Max Length must be 20 characters or less"],
    max30Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 30 || "Max Length must be 30 characters or less"],
    max50Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 50 || "Max Length must be 50 characters or less"],
    max100Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 100 || "Max Length must be 100 characters or less"],
  }),
  async created() {
    let dataSimple = await AddFavourite.getPageAction(this.userId, "document-account-add");
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.actionList = dataSimple.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.subPageUrl = data.subPageUrl;
    this.appPageName = data.appPageName;
    this.loadDropdowns();
    if (this.$route.params.accountMastersDetailsAdd !== undefined) {
      this.accountMastersDetails = JSON.parse(atob(this.$route.params.accountMastersDetailsAdd));
      this.accountManager = this.accountMastersDetails?.manager_name;
      this.backupManager = this.accountMastersDetails?.backup_manager_name;
      this.selectedAccountName = this.accountMastersDetails?.account_id;
      this.disableAccountName = true;
    } else {
      this.accountMastersDetails = [];
    }
  },
  mounted() {
    router.afterEach((to) => {
      if (
        !to.path.includes("document-account-add") &&
        !to.path.includes("document-account-edit") &&
        !to.path.includes("document-account-list") &&
        !to.path.includes("document-account-details")
      ) {
        EncryptUtility.localStorageRemoveItem("accountMastersDetails");
      }
    });
  },
  methods: {
    resetFunction() {
      this.selectedAccountName = "";
      this.accountOptions = [];
      this.accountManager = "";
      this.backupManager = "";
      this.selectedOriginID = "";
      this.originOptions = [];
      this.selectedTypeName = "";
      this.typeOptions = [];
      this.selectedDocumentNum = "";
      this.documentTitle = "";
      this.versionRevision = "";
      this.author = "";
      this.engineer = "";
      this.engineerOptions = [];
      this.authorOptions = [];
      this.timeRequired = "";
      this.statusID = "";
      this.statusOptions = "";
      this.difficultyID = "";
      this.difficultyOptions = [];
      this.managementDoc = false;
      this.applicablePersonnel = "";
      this.personnelOptions = [];
      this.trainingRequired = false;
      this.file = "";
      this.dragging = false;
      this.disableSubmit = true;
      this.disableAccountName = false;
      this.draftVersion = false;
      this.disableSaveDraftVersion = false;
      this.loadDropdowns();
      this.fileOther = [];
      this.draggingOther = false;
      if (this.accountMastersDetails !== []) {
        this.accountManager = this.accountMastersDetails?.manager_name;
        this.backupManager = this.accountMastersDetails?.backup_manager_name;
        this.selectedAccountName = this.accountMastersDetails?.account_id;
        this.disableAccountName = true;
      }
    },
    async loadDropdowns() {
      let masterObj = {
        pass: 0,
        user_id: parseInt(this.userId),
      };
      let masterData = await documentService.documentLoadMasters("post", masterObj, false);
      if (masterData.message !== "NA") {
        this.accountOptions = masterData.document_account;
        this.originOptions = masterData.document_origin;
        this.typeOptions = masterData.document_type;
        this.statusOptions = masterData.document_status;
        this.difficultyOptions = masterData.document_difficulty;
        this.personnelOptions = masterData.applicable_personnel;
        this.engineerOptions = masterData.document_engineer;
        this.authorOptions = masterData.document_author;
      }
    },
    //Drag and Drop Start
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.dragging = false;
        return;
      } else {
        this.noFiles = false;
        this.createFile(files[0]);
      }
    },
    //Checking file details
    createFile(file) {
      const allowedExtensions = [".pdf"]; // add as needed
      const fileName = file.name.toLowerCase();
      const isValid = allowedExtensions.some((ext) => fileName.endsWith(ext));
      if (!isValid) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Invalid file type. Please select a PDF.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.noFiles = true;
        this.dragging = false;
        return;
      }
      if (file.size > 50000000) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Size is more than 50MB",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.noFiles = true;
        this.dragging = false;
        return;
      }
      this.file = file;
      this.dragging = false;
      this.disableSubmit = false;
    },
    //Removing dragged file
    removeFile() {
      this.file = "";
      this.noFiles = true;
    },
    //Drag and Drop Start
    onChangeOther(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files || !files.length) {
        this.draggingOther = false;
        return;
      }
      if (files.length + this.fileOther.length > 10) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "You can upload a maximum of 10 files only.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.draggingOther = false;
        return;
      }
      this.noOtherFiles = false;
      for (let i = 0; i < files.length; i++) {
        this.createOtherFile(files[i]);
      }
      this.draggingOther = false;
      e.target.value = null;
    },
    //Checking file details
    createOtherFile(file) {
      const allowedExtensions = [".pdf", ".docx", ".xlsx", ".ppt", ".pptx", ".png"];
      const fileName = file.name.toLowerCase();
      const isValid = allowedExtensions.some((ext) => fileName.endsWith(ext));
      if (!isValid) {
        this.$store.commit("ConfigModule/Alert", {
          type: "error",
          isShow: true,
          message: "Invalid file type.",
        });
        return;
      }
      if (file.size > 50000000) {
        this.$store.commit("ConfigModule/Alert", {
          type: "error",
          isShow: true,
          message: "Size is more than 50MB",
        });
        return;
      }
      const alreadyExists = this.fileOther.some((f) => f.name === file.name && f.size === file.size);
      if (alreadyExists) return;
      this.fileOther.push(file);
    },
    //Removing dragged file
    removeOtherFile(index) {
      this.fileOther.splice(index, 1);
      if (this.fileOther.length == 0) {
        this.noOtherFiles = true;
      }
    },
    //On Account Change
    onAccountChange(value) {
      const selected = this.accountOptions.find((acc) => acc.account_id === value);
      if (selected) {
        this.accountManager = selected.manager_name;
        this.backupManager = selected.backup_manager_name;
        this.disableAccountName = true;
      } else {
        this.accountManager = "";
        this.backupManager = "";
        this.disableAccountName = false;
      }
    },
    submitNewDocument() {
      if (this.$refs.documentAddForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        const payload = this.applicablePersonnel.join(",");
        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("user_id", parseInt(this.userId));
        formData.append("account_key", this.selectedAccountName);
        formData.append("origin_key", parseInt(this.selectedOriginID));
        formData.append("type_key", parseInt(this.selectedTypeName));
        formData.append("document_number", this.selectedDocumentNum.toUpperCase());
        formData.append("title", this.documentTitle.toUpperCase());
        formData.append("revision", this.versionRevision.toUpperCase());
        formData.append("author_key", parseInt(this.author));
        formData.append("engineer_key", parseInt(this.engineer));
        formData.append("status_key", parseInt(this.statusID));
        formData.append("difficulty_key", parseInt(this.difficultyID));
        formData.append("time_required", this.timeRequired.toUpperCase());
        formData.append("is_managment_doc", this.managementDoc);
        formData.append("app_personnel_roles", payload);
        formData.append("is_training_required", this.trainingRequired);
        formData.append("is_draft_version", this.draftVersion);
        formData.append("version_number", this.versionRevision.toUpperCase());
        formData.append("original_file_name", this.file?.name);
        formData.append("system_file_name", "");
        formData.append("filepath", "");
        this.axios
          .post("/du/document_insert", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let data = JSON.parse(response.data.body.message);
              let Alert = {
                type: "success",
                isShow: true,
                message: data.Message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.$router.push({
                name: "documentMastersAccountEdit",
                params: {
                  accountMastersEditID: btoa(data.document_id.toString()),
                },
              });
              this.submitReferenceDocument(data.document_id);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    submitReferenceDocument(documentId) {
      if (this.fileOther.length !== 0) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.fileOther.forEach((file) => {
          const formData = new FormData();
          formData.append("file", file); // ✅ use current file
          formData.append("pass", 1);
          formData.append("document_id", parseInt(documentId));
          formData.append("user_id", parseInt(this.userId));
          formData.append("reference_id", 0);
          formData.append("original_file_name", file?.name); // ✅ use current file
          formData.append("system_file_name", "");
          formData.append("file_path", "");
          this.axios
            .post("/du/reference_document_insert", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        });
      }
    },
    //Document Status Change
    changeDocumentStatus() {
      if (this.statusID == 1 || this.statusID == 6 || this.statusID == 5) {
        this.disableSaveDraftVersion = false;
      } else if (this.statusID == 4 || this.statusID == 3) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "You cannot set the status to Approved or Management Review, as the document must first pass through the initial approval stage.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.statusID = "";
        this.disableSaveDraftVersion = true;
      } else if (this.statusID == 2) {
        this.draftVersion = false;
        this.disableSaveDraftVersion = true;
      } else {
        this.disableSaveDraftVersion = true;
      }
    },
    //Change in Engineer
    changeEngineer() {
      if (this.accountMastersDetails !== []) {
        if (this.accountMastersDetails?.manager_id == this.engineer) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Engineer cannot be same as Account Manager",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.engineer = "";
        }
      }
    },
    actionSetter(permission) {
      return Utility.actionSetter(this.actionList, permission);
    },
    documentRedirect() {
      let accountDetails = EncryptUtility.localStorageDecrypt("accountMastersDetails");
      if (accountDetails !== undefined) {
        this.$router.push({
          name: "documentMastersAccountList",
          params: {
            accountMastersDetails: btoa(accountDetails),
          },
        });
      } else {
        this.$router.push("/document-account-list");
      }
    },
  },
  components: {
    breadcrumbComp,
  },
};
